"use client";

import SinglePageHeaderSkeleton from "@/components/admin/pages/utils/SinglePageHeaderSkeleton";
import WebLayout from "@/components/layout/web/WebLayout";
import { Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <>
      <SinglePageHeaderSkeleton />
      <div className="max-w-[900px] mx-auto px-5">
        <Skeleton height={130} className="max-w-[860px] sm:mt-[110px] my-10" />
      </div>
    </>
  );
};

export default WebLayout(loading);
